export default __webpack_public_path__ + "static/media/cuprum.31c30f9c.png";